import {Outlet} from 'react-router-dom';

const DashboardAdmin = (props) => {
  return <Outlet/>;
};

export default DashboardAdmin;
